import {Injectable} from '@angular/core';
import {GapQuoteDetailsResponse} from '../../models/gap-quote-details-response';
import {HealthPolicyMembers} from '../../models/health-policy-members';
import {GapPremiumsResponse} from '../../models/gap-premiums-response';
import {HealthPolicyMember} from '../../models/health-policy-member';
import {QuotePdfResponse} from '../../models/quote-pdf-response';

@Injectable()
export class GlobalService {

  private _leadId: string;
  private _includedSIB: boolean;
  private _effectiveDate: string;
  private _memberSmoker: string;
  private _spouseSmoker: string;
  private _clientEmail: string;
  private _quoteRef: string;
  private _returnedToHomePage: boolean;
  private _spouses: Array<HealthPolicyMember>;
  private _children: Array<HealthPolicyMember>;
  private _adults: Array<HealthPolicyMember>;
  private _mainHealthPolicyMember: HealthPolicyMember;
  private _spouse: HealthPolicyMember;
  private _gapQuoteDetailsResponse: GapQuoteDetailsResponse;
  private _healthPolicyMembers: HealthPolicyMembers;
  private _gapPremiumsResponse: GapPremiumsResponse;
  private _quotePdfResponse: QuotePdfResponse;

  get leadId(): string {
    return this._leadId;
  }

  set leadId(value: string) {
    this._leadId = value;
  }

  get gapQuoteDetailsResponse(): GapQuoteDetailsResponse {
    return this._gapQuoteDetailsResponse;
  }

  set gapQuoteDetailsResponse(value: GapQuoteDetailsResponse) {
    this._gapQuoteDetailsResponse = value;
  }

  get healthPolicyMembers(): HealthPolicyMembers {
    return this._healthPolicyMembers;
  }

  set healthPolicyMembers(value: HealthPolicyMembers) {
    this._healthPolicyMembers = value;
  }

  get gapPremiumsResponse(): GapPremiumsResponse {
    return this._gapPremiumsResponse;
  }

  set gapPremiumsResponse(value: GapPremiumsResponse) {
    this._gapPremiumsResponse = value;
  }

  get includedSIB(): boolean {
    return this._includedSIB;
  }
  set includedSIB(value: boolean) {
    this._includedSIB = value;
  }

  get mainMember(): HealthPolicyMember {
    return this._mainHealthPolicyMember;
  }
  set mainMember(value: HealthPolicyMember) {
    this._mainHealthPolicyMember = value;
  }

  get firstSpouse(): HealthPolicyMember {
    return this._spouse;
  }
  set firstSpouse(value: HealthPolicyMember) {
    this._spouse = value;
  }

  get effectiveDate(): string {
    return this._effectiveDate;
  }
  set effectiveDate(value: string) {
    this._effectiveDate = value;
  }

  get memberSmoker(): string {
    return this._memberSmoker;
  }
  set memberSmoker(value: string) {
    this._memberSmoker = value;
  }

  get spouseSmoker(): string {
    return this._spouseSmoker;
  }
  set spouseSmoker(value: string) {
    this._spouseSmoker = value;
  }

  get spouses(): Array<HealthPolicyMember> {
    return this._spouses;
  }
  set spouses(value: HealthPolicyMember[]) {
    this._spouses = value;
  }

  get children(): Array<HealthPolicyMember> {
    return this._children;
  }
  set children(value: HealthPolicyMember[]) {
    this._children = value;
  }

  get adults(): Array<HealthPolicyMember> {
    return this._adults;
  }
  set adults(value: HealthPolicyMember[]) {
    this._adults = value;
  }

  get clientEmail(): string {
    return this._clientEmail;
  }
  set clientEmail(value: string) {
    this._clientEmail = value;
  }

  get quoteRef(): string {
    return this._quoteRef;
  }

  set quoteRef(value: string) {
    this._quoteRef = value;
  }

  get returnedToHome(): boolean {
    return this._returnedToHomePage;
  }
  set returnedToHome(value: boolean) {
    this._returnedToHomePage = value;
  }

  get quotePdfResponse(): QuotePdfResponse {
    return this._quotePdfResponse;
  }

  set quotePdfResponse(value: QuotePdfResponse) {
    this._quotePdfResponse = value;
  }

  scrollToTop(): void {
    window.scrollTo({behavior: 'smooth', top: 0});
    window.parent.scrollTo({behavior: 'smooth', top: 0});
  }

  calculateAge(dob: string): number {
    const birthDate = new Date(dob);
    const today = new Date();

    let age = today.getFullYear() - birthDate.getFullYear();
    const month = today.getMonth() - birthDate.getMonth();

    if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }
}
